import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-maroon to-primary text-light border-t-4 border-accent py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-light rounded-lg flex items-center justify-center shadow-md">
                <span className="text-maroon font-bold text-sm">SB</span>
              </div>
              <h3 className="text-lg font-bold text-light">SocialBoost</h3>
            </div>
            <p className="text-light/80 text-sm">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-accent">{t('footer.servicesTitle')}</h4>
            <ul className="space-y-2 text-light/80 text-sm">
              <li><a href="#services" className="hover:text-light transition">{t('services.comments')}</a></li>
              <li><a href="#services" className="hover:text-light transition">{t('services.likes')}</a></li>
              <li><a href="#services" className="hover:text-light transition">{t('services.views')}</a></li>
              <li><a href="#services" className="hover:text-light transition">{t('services.shares')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-accent">{t('footer.companyTitle')}</h4>
            <ul className="space-y-2 text-light/80 text-sm">
              <li><a href="#" className="hover:text-light transition">{t('footer.companyAbout')}</a></li>
              <li><a href="#" className="hover:text-light transition">{t('footer.companyBlog')}</a></li>
              <li><a href="#" className="hover:text-light transition">{t('footer.companyCareers')}</a></li>
              <li><a href="#contact" className="hover:text-light transition">{t('footer.companyContact')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-accent">{t('footer.legalTitle')}</h4>
            <ul className="space-y-2 text-light/80 text-sm">
              <li><a href="#" className="hover:text-light transition">{t('footer.privacy')}</a></li>
              <li><a href="#" className="hover:text-light transition">{t('footer.terms')}</a></li>
              <li><a href="#" className="hover:text-light transition">{t('footer.legalUsagePolicy')}</a></li>
              <li><a href="#" className="hover:text-light transition">{t('footer.legalTermsConditions')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-light/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-light/80 text-sm">
              © {currentYear} SocialBoost. {t('footer.rights')}
            </p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <a href="#" className="text-light/80 hover:text-light transition">
                <span className="sr-only">Facebook</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="#" className="text-light/80 hover:text-light transition">
                <span className="sr-only">Twitter</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2s9 5 20 5a9.5 9.5 0 00-9-5.5c4.75 2.25 7-7 7-7a10.6 10.6 0 01-9.5 5"/>
                </svg>
              </a>
              <a href="#" className="text-light/80 hover:text-light transition">
                <span className="sr-only">Instagram</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
